// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 3/11/2023
 */

.AvailabilityStep_container__pLfvd{
    margin-top: 2rem;
}

.AvailabilityStep_paper__WgU7u {
    padding: 1.5rem 0;
    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
}

.AvailabilityStep_topic__RR3p0 {
    font-size: 1.6rem;
    font-style: normal;
    font-weight: 600;
    margin: 0 1.5rem 1.5rem 2.38rem;
}

.AvailabilityStep_inputContainer__BivsT {
    margin: 1.5rem 0.1rem;
}

.AvailabilityStep_subTitle__mz91S {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    margin-left: 2.28rem;
}

/* for mobile */
@media (max-width: 770px) {
    .AvailabilityStep_paper__WgU7u {
        background: #FFF;
    }
    .AvailabilityStep_topic__RR3p0 {
        font-size: 1.5rem;
        font-weight: 600;
    }
    .AvailabilityStep_subTitle__mz91S {
        font-size: 1rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Checkout/AvailabilityStep.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gGAAgG;AACpG;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,+BAA+B;AACnC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA,eAAe;AACf;IACI;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 3/11/2023\r\n */\r\n\r\n.container{\r\n    margin-top: 2rem;\r\n}\r\n\r\n.paper {\r\n    padding: 1.5rem 0;\r\n    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n}\r\n\r\n.topic {\r\n    font-size: 1.6rem;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    margin: 0 1.5rem 1.5rem 2.38rem;\r\n}\r\n\r\n.inputContainer {\r\n    margin: 1.5rem 0.1rem;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 1rem;\r\n    font-style: normal;\r\n    font-weight: 400;\r\n    margin-left: 2.28rem;\r\n}\r\n\r\n/* for mobile */\r\n@media (max-width: 770px) {\r\n    .paper {\r\n        background: #FFF;\r\n    }\r\n    .topic {\r\n        font-size: 1.5rem;\r\n        font-weight: 600;\r\n    }\r\n    .subTitle {\r\n        font-size: 1rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AvailabilityStep_container__pLfvd`,
	"paper": `AvailabilityStep_paper__WgU7u`,
	"topic": `AvailabilityStep_topic__RR3p0`,
	"inputContainer": `AvailabilityStep_inputContainer__BivsT`,
	"subTitle": `AvailabilityStep_subTitle__mz91S`
};
export default ___CSS_LOADER_EXPORT___;
